let REACT_APP_MIRUM_SERVER_BASE_URL =
  process.env.REACT_APP_MIRUM_SERVER_BASE_URL;
// let REACT_APP_MIRUM_BASE_URL = REACT_APP_MIRUM_SERVER_BASE_URL;
let REACT_APP_MIRUM_CLIENT_BASE_URL =
  process.env.REACT_APP_MIRUM_CLIENT_BASE_URL;

if (!REACT_APP_MIRUM_SERVER_BASE_URL) {
  console.error(
    "REACT_APP_MIRUM_SERVER_BASE_URL is not set in the environment!"
  );
  REACT_APP_MIRUM_SERVER_BASE_URL = "https://localhost.letscreate.zone:3001";
  console.warn(
    "REACT_APP_MIRUM_SERVER_BASE_URL not set - it has now been defaulted as",
    REACT_APP_MIRUM_SERVER_BASE_URL
  );
}

if (!REACT_APP_MIRUM_CLIENT_BASE_URL) {
  console.error(
    "REACT_APP_MIRUM_CLIENT_BASE_URL is not set in the environment!"
  );
  REACT_APP_MIRUM_CLIENT_BASE_URL = "https://localhost.letscreate.zone:8443";
  console.warn(
    "REACT_APP_MIRUM_CLIENT_BASE_URL not set - it has now been defaulted as",
    REACT_APP_MIRUM_CLIENT_BASE_URL
  );
}

export { REACT_APP_MIRUM_SERVER_BASE_URL, REACT_APP_MIRUM_CLIENT_BASE_URL };
